import React from "react";
import { TrendingUp, Receipt, CalendarDays } from "lucide-react";
import { COLORS } from "../../utils/constants";
import { formatCurrency } from "../../utils/formatters";

const Card = ({ icon: Icon, label, value, sub, color, testid }) => (
  <div className="rounded-xl border p-4 bg-white" style={{ borderColor: color + "55" }} data-testid={testid}>
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground mb-1"><Icon size={14} /> {label}</div>
    <div className="text-2xl font-bold" style={{ color }}>{value}</div>
    {sub && <div className="text-xs text-muted-foreground mt-0.5">{sub}</div>}
  </div>
);

export const ResumeCards = ({ sim }) => {
  const pct = sim.total_contrat > 0 ? Math.round((sim.total_net / sim.total_contrat) * 100) : 0;
  const t = sim.taux;
  const detail = [`cotisations ${t.urssaf}%${t.acre_actif ? " (ACRE)" : ""}`, `CFP ${t.cfp}%`];
  if (t.taxe_consulaire > 0) detail.push(`taxe consulaire ${t.taxe_consulaire}%`);
  if (t.versement_liberatoire > 0) detail.push(`versement libératoire ${t.versement_liberatoire}%`);
  return (
    <div className="grid sm:grid-cols-3 gap-4" data-testid="simulateur-resume">
      <Card icon={TrendingUp} label="Ce qui te reste au total" value={formatCurrency(sim.total_net)} sub={`soit ${pct}% du contrat`} color={COLORS.success} testid="simulateur-total-net" />
      <Card icon={Receipt} label="À verser à l'Urssaf" value={formatCurrency(sim.total_prelevements)} sub={detail.join(" · ")} color={COLORS.accent} testid="simulateur-total-urssaf" />
      <Card
        icon={CalendarDays}
        label="Contrat"
        value={formatCurrency(sim.total_contrat)}
        sub={sim.mode === "mensuel" ? `${sim.nb_mois} mois × ${formatCurrency(sim.mensuel[0]?.encaissement || 0)}` : `encaissé en ${sim.mensuel[0]?.label}`}
        color={COLORS.text}
        testid="simulateur-total-contrat"
      />
    </div>
  );
};

export default ResumeCards;
